import { Constant } from '../Actions/Constant'
const INITIAL_STATE = {
    industryList: [],
}
export default (state = INITIAL_STATE, action) => {
    let data;
    switch (action.type) {
        case Constant.FETCHINDUSTRYLIST:
            return ({
                ...state,
                industryList: action.payload.data.data,
            })

        case Constant.ADDINDUSTRY:
            data = state.industryList;
            data.unshift(action.payload)
            return ({
                ...state,
                industryList: data,
            })
        case Constant.DELETEINDUSTRY:
            data = state.industryList;
            let temp = data.filter(a => a.id != action.payload)
            return ({
                ...state,
                industryList: temp,
            })
        case Constant.UPDATEINDUSTRY:
            data = state.industryList;
            let index = data.findIndex(a => a.id == action.payload.id)
            data.splice(index, 1, action.payload)

            return ({
                ...state,
                industryList: data,
            })


        default:
            return state;

    }

}